<template>
  <div>
    <v-dialog v-model="isOpen" max-width="400" persistent>
      <v-card class="confirm-card" elevation="0">
        <div class="content">
          <v-icon class="mb-3" color="#39404B" size="34">$Warning</v-icon>

          <div class="title">Aplicar Compra Sazonal?</div>

          <div class="subtitle">
            Você está aplicando esta configuração para <b>{{ qtd_items_escopo }}</b> iten(s). As sugestões de compra nos períodos de compra das rodadas serão influenciadas.
          </div>

          <v-btn class="btn-cancel" block large outlined @click="cancelar">
            Cancelar
          </v-btn>

          <v-btn class="btn-delete" block large depressed @click="confirmar">
            Confirmar aplicação
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";

const emit = defineEmits(["fechar", "confirmar"]);

const props = defineProps({
  value: { type: Boolean, default: false },
  qtd_items_escopo: { type: Number, required: false, default: 0 }
});

const dialog = ref(props.value);

watch(
  () => props.value,
  (v) => (dialog.value = v)
);

const isOpen = computed({
  get: () => dialog.value,
  set: (v) => (dialog.value = v),
});

function cancelar() {
  isOpen.value = false;
  emit("fechar");
}

function confirmar() {
    isOpen.value = false;

    emit("fechar");
    emit("confirmar");
}
</script>

<style scoped>
.confirm-card {
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
}

.content {
  padding: 28px 26px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.title {
  font-size: 20px;
  font-weight: 500;
  color: #39404B;
  margin-top: 10px;
  margin-bottom: 20px;
}

.subtitle {
  font-size: 16px;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.6);
  max-width: 420px;
  margin-bottom: 30px;
}

.btn-cancel {
  border-radius: 7px;
  border-width: 1px !important;
  border-color: #8CACFF !important;
  color: #4075FF !important;
  text-transform: none;
  font-weight: 500;
  height: 48px;
  margin-bottom: 12px;
}

.btn-delete {
  border-radius: 7px;
  background: #4075FF !important;
  color: #fff !important;
  text-transform: none;
  font-weight: 500;
  height: 50px;
}
</style>
